<template>
  <div id="inside" style="">
    <nav class="navbar3 navbar-light navbar-expand" v-if="!loading">
      <div class="container justify-content-center pt-0">
        <button
          class="navbar-toggler navbar-toggler-right border-0"
          type="button"
          data-toggle="collapse"
          data-target="#navbar3"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse text-center justify-content-center"
          id="navbar3"
        >
          <ul class="navbar-nav justify-content-between">
            <li
              v-bind:class="[
                this.currentPage !== 'meusAcordos'
                  ? 'nav-item border-bottom border-info mx-5 mb-2'
                  : 'nav-item mx-5',
              ]"
            >
              <a class="nav-link active" @click="home" style="cursor: pointer"
                >Propostas</a
              >
            </li>
            <li
              v-bind:class="[
                this.currentPage === 'meusAcordos'
                  ? 'nav-item border-bottom border-info mx-5 mb-2'
                  : 'nav-item mx-5',
              ]"
            >
              <a class="nav-link" @click="meusAcordos" style="cursor: pointer"
                >Acordos
                <span
                  class="badge badge-primary badge-pill"
                  v-if="agreements.length"
                  >{{ agreements !== null ? agreements.length : 0 }}</span
                >
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div v-bind:class="largura > 500 ? 'container' : ''">
      <!-- <div class="row"> -->
      <div class="row d-flex justify-content-center px16 my16">
        <div class="px-0 col-lg-12">
          <div class="stepper-wrapper">
            <div class="stepper-item completed">
              <div class="step-counter"></div>
            </div>
            <div class="stepper-item active">
              <div class="step-counter">2</div>
            </div>
            <div class="stepper-item">
              <div class="step-counter">3</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 col-lg-12 mt-3"> -->
      <div class="container mt-3">
        <div class="row">
          <div class="col-lg-12">
            <h6 class="mb-0" style="color: #3a4148; font-weight: 600">
              Tudo pronto? Revise as informações da negociação antes de
              finalizar o acordo.
            </h6>
          </div>
        </div>
      </div>
      <div class="d-inline-flex flex-wrap flex-column col-lg-12 mt-3">
        <!-- <div class="container"> -->
        <div class="card" v-if="!loading">
          <div class="card-header">
            <h6 class="mb-0 p-3" style="color: #3a4148; font-weight: 600">
              Resumo da negociação
            </h6>
          </div>
          <div class="card-body">
            <h6
              v-if="isUnica"
              class="mb-3"
              style="color: #3a4148; font-weight: 600"
            >
              Mensalidade POS Única
            </h6>
            <div class="background-resume">
              <div
                class="d-flex"
                style="justify-content: space-between; cursor: pointer"
                @click="openCloseContractsDetails"
              >
                <h6>Contrato(s)</h6>
                <i
                  class="fa fa-chevron-down fa-fw grey01 d-inline-block"
                  v-if="openContractDetails"
                ></i>
                <i
                  class="fa fa-chevron-up fa-fw grey01 d-inline-block"
                  v-if="!openContractDetails"
                ></i>
              </div>

              <div v-if="openContractDetails">
                <div
                  v-for="(contract, key, index) in agreementPayload.contracts"
                  :key="`${key}-${index}`"
                >
                  <hr />
                  <div class="d-flex" style="justify-content: space-between">
                    <p>Contrato</p>
                    <p style="font-weight: bold">{{ contract.contract }}</p>
                  </div>
                  <div class="d-flex" style="justify-content: space-between">
                    <p>Parcela negociada</p>
                    <p>{{ rangeParcelas(contract) }}</p>
                  </div>
                  <!-- <div
                    class="d-flex"
                    style="justify-content: space-between"
                    v-else
                  >
                    <p>Parcelas negociadas</p>
                    <p>
                      {{ contract.startInstallmentNumber }}/{{
                        contract.endInstallmentNumber
                      }}
                      a {{ contract.startInstallmentNumber }}/{{
                        contract.endInstallmentNumber
                      }}
                    </p>
                  </div> -->
                  <div class="d-flex" style="justify-content: space-between">
                    <p>Vencimento parcelas negociadas</p>
                    <p>
                      {{ rangeVenc(contract) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="">
              <div
                class="d-flex"
                style="justify-content: space-between"
                v-if="hasRealDiscount || isUnica"
              >
                <p>Valor atualizado</p>
                <p>
                  {{
                    formatFloatToReal(
                      parseFloat(totalExpenseAppliedAmount.toFixed(2), 10)
                    )
                  }}
                </p>
              </div>
              <div
                class="d-flex"
                style="justify-content: space-between"
                v-if="hasRealDiscount"
              >
                <p>Valor desconto</p>
                <p style="font-weight: bold">
                  {{
                    formatFloatToReal(
                      parseFloat(totalDiscountAppliedAmount.toFixed(2), 10)
                    )
                  }}
                </p>
              </div>
              <div
                class="d-flex"
                style="justify-content: space-between"
                v-if="hasRealDiscount"
              >
                <p>Percentual de desconto</p>
                <p>{{ totalDiscountAppliedPercentage.toFixed(2) }}%</p>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <p>Plano de pagamento</p>
                <p v-if="agreementPayload.installmentNumber === '0'">À vista</p>
                <p v-else>Parcelado</p>
              </div>
              <div
                v-if="agreementPayload.installmentNumber !== '0'"
                class="d-flex"
                style="justify-content: space-between"
              >
                <p>Entrada</p>
                <p style="font-weight: bold">
                  R$ {{ agreementPayload.inputValue }}
                </p>
              </div>
              <div
                v-if="agreementPayload.installmentNumber !== '0'"
                class="d-flex"
                style="justify-content: space-between"
              >
                <p>Parcelas</p>
                <p style="font-weight: bold">
                  + {{ agreementPayload.installmentNumber }}x R$
                  {{ agreementPayload.inputValue }}
                </p>
              </div>
              <div
                v-if="agreementPayload.installmentNumber === '0'"
                class="d-flex"
                style="justify-content: space-between"
              >
                <p>Valor à pagar</p>
                <p style="font-weight: bold">
                  {{ formatFloatToReal(parseBR(totalAmountToPay)) }}
                </p>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <p>
                  {{
                    agreementPayload.installmentNumber === "0"
                      ? "Vencimento do acordo"
                      : "Vencimento da entrada"
                  }}
                </p>
                <p>
                  {{
                    formatData(
                      agreementPayload.dueDate,
                      "YYYY-MM-DD",
                      "DD/MM/YYYY"
                    )
                  }}
                </p>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <p>Forma de pagamento</p>
                <p>Boleto</p>
              </div>
              <a
                class="btn mr-1 mt-3 mb-0 btn-outline-primary btn-block"
                href="#"
                v-if="loadingAgreement"
              >
                <ProgressLoading v-bind:loading="true"
              /></a>
            </div>
          </div>
        </div>

        <button
          class="btn btn-primary btn-block text-white mt-3"
          @click="openModalConfirmarAcordo()"
          style="cursor: pointer !important"
        >
          CONFIRMAR ACORDO
        </button>
        <a
          @click="voltar"
          class="text-center mt-4"
          style="text-decoration: underline; color: #03659b; cursor: pointer"
          >Voltar</a
        >

        <div class="card" v-if="loading">
          <ProgressLoading v-bind:loading="loading" />
        </div>
      </div>

      <div
        class="modal fade"
        id="confirmarAcordo"
        style="background-color: #000000a3"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirmar acordo</h5>
              <button type="button" @click="closeModalConfirmarAcordo()">
                <span style="font-size: 12pt">×</span>
              </button>
            </div>
            <div class="modal-body pt-0">
              <form class="mb-0">
                <div class="form-group my-0">
                  <div class="form-group mb-1">
                    <label>Você escolheu a opção:</label>
                    <div
                      class="contract-item"
                      v-if="agreementPayload.installmentNumber === '0'"
                    >
                      <p class="text-center" style="font-weight: bold">
                        À vista:
                        {{
                          formatFloatToReal(parseBR(totalAmountToPay))
                        }}
                      </p>
                    </div>
                    <div class="contract-item" v-else>
                      <p class="text-center" style="font-weight: bold">
                        Parcelado: Entrada de R$
                        {{ agreementPayload.inputValue }} <br />
                        + {{ agreementPayload.installmentNumber }}x R$
                        {{ agreementPayload.inputValue }}
                      </p>
                    </div>
                  </div>
                </div>
              </form>
              <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loadingUpdateOffer ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
              <button
                class="btn btn-primary btn-block mt-4"
                @click="setAgreement()"
              >
                CONFIRMAR ACORDO
              </button>
              <button
                class="btn btn-link btn-block"
                :disabled="loadingAgreement"
                @click="closeModalConfirmarAcordo()"
              >
                CANCELAR
              </button>
              <ProgressLoading v-bind:loading="loadingAgreement" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  formatDocument,
  parseBR,
  formatFloatToReal,
} from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";
import { sendAgreementCompletedBeacon } from "@/utils/abandonmentBeacon";

export default {
  name: "HistoricoPagamentos",
  components: {
    ProgressLoading,
  },
  data() {
    return {
      containParcel: false,
      loading: true,
      loadingAgreement: false,
      parcelado: false,
      currentPage: "resumoAcordo",
      openContractDetails: true,
      largura: null,
      agreementPayload: null,
      totalAmountToPay: null,
      totalAmountOriginalValue: null,
      totalDiscountAppliedPercentage: null,
      totalDiscountAppliedAmount: null,
      totalExpenseAppliedAmount: null
    };
  },
  async created() {
    this.largura = window.screen.width;
    const payload = localStorage.getItem("agreementPayload");
    this.agreementPayload = payload ? JSON.parse(payload) : null;

    console.log("agreementPayload: " + JSON.stringify(this.agreementPayload));

    this.ipUser = localStorage.getItem("ipUser") ?? "";
    this.userAdm = JSON.parse(localStorage.getItem("userAdm"));
    this.largura = window.screen.width;

    this.contract = this.$route.params.contract;
    this.installment = this.$route.params.installment;

    const agreements = localStorage.getItem("agreements");
    this.agreements = agreements ? JSON.parse(agreements) : null;

    if (!this.agreementPayload) {
      // fallback defensivo
      this.$router.push({
        name: "dashboard",
      });
    }

    this.organizeValues(this.agreementPayload.contracts);
    this.loading = false;
  },
  methods: {
    formatValue,
    formatData,
    formatDocument,
    formatFloatToReal,
    parseBR,

    ...mapActions("minhasDividas", [
      "ActionDividaNegociar",
      "ActionContractsAgreementResume",
      "ActionContractsAgreement",
      "ActionSetAgreement",
    ]),

    organizePayloadAgreement() {
      try {
        this.arrayToCall = [];

        const thisContract = {
          document: this.agreementPayload.document,
          credor: this.agreementPayload.credor,
          company: this.agreementPayload.company,
          inputValue: this.agreementPayload.inputValue,
          // installmentNumber: String(installmentNumber),
          installmentNumber: String(this.agreementPayload.installmentNumber),
          installments: [],
          dueDate: this.agreementPayload.dueDate,
          tag: localStorage.getItem("tag"),
        };

        (this.agreementPayload.installments || []).forEach((installment) => {
          thisContract.installments.push({
            contract: installment.contract,
            product: installment.product,
            dueInstallmentDate: installment.dueInstallmentDate, // se precisar ISO, converta aqui também
          });
        });

        this.arrayToCall.push(thisContract);

        const reqAgreement = {
          ...this.arrayToCall[0],
          installments: [],
          source: 1,
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser,
        };

        (this.agreementPayload.installments || []).forEach((installment) => {
          reqAgreement.installments.push(installment);
        });

        return reqAgreement;
      } catch (e) {
        this.loadDeal = !this.loadDeal;
        this.loadingAgreement = false;
        throw e;
      }
    },

    async setAgreement() {
      this.loadingAgreement = true;

      try {
        var payload = await this.organizePayloadAgreement();
        this.responseAgreement = await this.ActionSetAgreement(payload);

        if (this.responseAgreement) {
          this.flashMessage.show({
            timeout: 300,
            status: "success",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Sucesso",
            message: "Acordo realizado com sucesso!",
          });

          sendAgreementCompletedBeacon(
            this.user?.DebtorID,
            this.$store.state.auth.ownerId,
          );

          this.closeModalConfirmarAcordo();

          this.$router.push({
            name: "concluir",
            params: { responseAgreement: this.responseAgreement },
          });
        }

        this.loadDeal = !this.loadDeal;
        this.loadingAgreement = false;
      } catch (error) {
        this.loadingAgreement = false;
      }

      // this.$router.push({
      //   name: "concluir",
      //   // params: { agreement: this.contracts },
      // });
    },

    home() {
      localStorage.setItem("currentPage", "dashboard");
      if (this.$route.name !== "dashboard") {
        this.$router.push({ name: "dashboard" });
      }
    },

    meusAcordos() {
      localStorage.setItem("currentPage", "meusAcordos");
      this.$router.push({ name: "meusAcordos" });
    },

    openCloseContractsDetails() {
      this.openContractDetails = !this.openContractDetails;
    },

    voltar() {
      this.$router.push({
        name: "dashboard",
      });
    },

    openModalConfirmarAcordo() {
      // this.validateProposalOptions();
      const modal = document.getElementById("confirmarAcordo");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalConfirmarAcordo() {
      document.getElementById("confirmarAcordo").style.display = "none";
    },

    sumTotalAmountOriginalValue(items) {
      this.totalAmountOriginalValue = items.reduce(
        (acc, it) => acc + parseBR(it.originalValue),
        0
      );

      return this.totalAmountOriginalValue;
    },

    sumTotalAmountToPay(items) {
      this.totalAmountToPay = items.reduce(
        (acc, it) => acc + parseBR(it.updatedValue),
        0
      );

      return this.totalAmountToPay;
    },

    sumTotalDiscountAppliedPercentage(items) {
      console.log('items: ' + JSON.stringify(items));
      
      // Para Tribanco, usar o primeiro item (já que todos têm o mesmo percentual)
      if (items && items.length > 0) {
        const firstItem = items[0];
        const discountValue = firstItem.discountPercentage;
        
        // Se o valor já vem como string com % (ex: "99.78"), usar diretamente
        if (typeof discountValue === 'string' && discountValue.includes('.')) {
          this.totalDiscountAppliedPercentage = parseFloat(discountValue);
        } else {
          // Se vem como número, usar parseBR
          this.totalDiscountAppliedPercentage = parseBR(discountValue) || 0;
        }
      } else {
        this.totalDiscountAppliedPercentage = 0;
      }
      
      return this.totalDiscountAppliedPercentage;
    },

    sumTotalDiscountAppliedAmount(items) {
      this.totalDiscountAppliedAmount = items.reduce(
        (acc, it) => acc + parseBR(it.discountValue),
        0
      );
      return this.totalDiscountAppliedAmount;
    },

    sumTotalExpenseAppliedAmount(items) {
      console.log('items: ' + JSON.stringify(items));
      this.totalExpenseAppliedAmount = items.reduce(
        (acc, it) => acc + parseBR(it.expenseValue),
        0
      );
      return this.totalExpenseAppliedAmount;
    },

    organizeValues(contracts) {
      this.sumTotalAmountToPay(contracts);
      this.sumTotalDiscountAppliedAmount(contracts);
      this.sumTotalExpenseAppliedAmount(contracts);
      this.sumTotalAmountOriginalValue(contracts);

      this.sumTotalDiscountAppliedPercentage(contracts);
    },

    toBR(iso) {
      if (!iso) return "";
      const [y, m, d] = iso.split("-");
      return `${d}/${m}/${y.slice(2)}`;
    },
    rangeParcelas(c) {
      console.log("c: " + JSON.stringify(c));
      // "1/9 a 9/9"
      return `${c.startInstallmentNumber}/${c.totalInstallments} a ${c.endInstallmentNumber}/${c.totalInstallments}`;
    },
    rangeVenc(c) {
      // "27/09/14 a 27/05/15"
      return `${this.toBR(c.startDueInstallmentDate)} a ${this.toBR(
        c.endDueInstallmentDate
      )}`;
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("minhasDividas", [
      "agreementResume",
      "contractNegotiable",
      "contractNegotiableOptions",
    ]),
    isUnica() {
      return (
        String(this.agreementPayload?.credor || "").toUpperCase() === "UNICA"
      );
    },
    hasRealDiscount() {
      const amount = Number(this.totalDiscountAppliedAmount) || 0;
      const pct = Number(this.totalDiscountAppliedPercentage) || 0;
      if (amount > 0 || pct > 0) return true;

      const original = Number(this.totalExpenseAppliedAmount) || 0;
      const toPay = Number(this.totalAmountToPay) || 0;
      return original > 0 && toPay > 0 && original > toPay;
    },
  },
};
</script>
<style scoped>
</style>
